/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProtocolType {
  Impulse = 'Impulse',
  Practice = 'Practice'
}
